import type { ReactNode } from "react";
import { NovaraLogo } from "./NovaraLogo.js";

// Sticky black brand bar with the white Novara logo, the app title, and the Novara Glow strip
// under it: the same header as it-assets.
export function SiteHeader({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <header className="sitehead">
      <div className="brandbar">
        <div className="brandbar-in">
          <NovaraLogo />
          <h1>{title}</h1>
          {children ? <nav aria-label="Main">{children}</nav> : null}
        </div>
      </div>
      <div className="glow" aria-hidden="true" />
    </header>
  );
}
